export default "__VITE_ASSET__d8455195__"